export const ELEVENLABS_CONFIG = {
  BASE_URL: "https://api.elevenlabs.io/v1/convai",
  API_KEY: "sk_8e3d558c649a1166e18c6dabb944fe0616e05d07f7cd2706",
  HEADERS: {
    "xi-api-key": process.env.REACT_SK_API_KEY,
    "Content-Type": "application/json",
  },
  AGENT_PHONE_NUMBER_ID: "phnum_2101kht9kpskfmp8mdmpw1pq9cvd",
};

export const getElevenLabsHeaders = () => ({
  "xi-api-key": ELEVENLABS_CONFIG.API_KEY,
  "Content-Type": "application/json",
});
